import { z } from "zod";
import { installationArray } from "./installation";

export const brandModelsSchema = z.object({
  brand: z.string(),
  installations: installationArray,
});

export type BrandModelsType = z.infer<typeof brandModelsSchema>;
